export default function Machines_D_8 (number = 1) {
  return {
    name: '轨道采集器',
    icon: '/static/img/machines/d8.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_D/Machines_D_8.js